export const passwordRegex = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,32}$/;
